import _toConsumableArray from "/opt/peech/reactor/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/opt/peech/reactor/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/peech/reactor/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _slicedToArray from "/opt/peech/reactor/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { S as SUPPORT, C as ConfigResolverMap, _ as _objectSpread2, a as _defineProperty, t as toDomEventType, i as isTouch, b as touchIds, E as EngineMap, c as chain, p as parseProp, d as toHandlerProp } from './actions-65020aef.esm.js';
import './maths-b2a210f4.esm.js';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var sharedConfigResolver = {
  target: function target(value) {
    if (value) {
      return function () {
        return 'current' in value ? value.current : value;
      };
    }

    return undefined;
  },
  enabled: function enabled() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  },
  window: function (_window) {
    function window() {
      return _window.apply(this, arguments);
    }

    window.toString = function () {
      return _window.toString();
    };

    return window;
  }(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SUPPORT.isBrowser ? window : undefined;
    return value;
  }),
  eventOptions: function eventOptions() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$passive = _ref2.passive,
        passive = _ref2$passive === void 0 ? true : _ref2$passive,
        _ref2$capture = _ref2.capture,
        capture = _ref2$capture === void 0 ? false : _ref2$capture;

    return {
      passive: passive,
      capture: capture
    };
  },
  transform: function transform(value) {
    return value;
  }
};
var _excluded = ["target", "eventOptions", "window", "enabled", "transform"];

function resolveWith() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var resolvers = arguments.length > 1 ? arguments[1] : undefined;
  var result = {};

  for (var _i = 0, _Object$entries = Object.entries(resolvers); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        resolver = _Object$entries$_i[1];

    switch (typeof resolver) {
      case 'function':
        if (process.env.NODE_ENV === 'development') {
          var r = resolver.call(result, config[key], key, config);
          if (!Number.isNaN(r)) result[key] = r;
        } else {
          result[key] = resolver.call(result, config[key], key, config);
        }

        break;

      case 'object':
        result[key] = resolveWith(config[key], resolver);
        break;

      case 'boolean':
        if (resolver) result[key] = config[key];
        break;
    }
  }

  return result;
}

function parse(config, gestureKey) {
  var _ref = config,
      target = _ref.target,
      eventOptions = _ref.eventOptions,
      window = _ref.window,
      enabled = _ref.enabled,
      transform = _ref.transform,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _config = {
    shared: resolveWith({
      target: target,
      eventOptions: eventOptions,
      window: window,
      enabled: enabled,
      transform: transform
    }, sharedConfigResolver)
  };

  if (gestureKey) {
    var resolver = ConfigResolverMap.get(gestureKey);
    _config[gestureKey] = resolveWith(_objectSpread2({
      shared: _config.shared
    }, rest), resolver);
  } else {
    for (var key in rest) {
      var _resolver = ConfigResolverMap.get(key);

      if (_resolver) {
        _config[key] = resolveWith(_objectSpread2({
          shared: _config.shared
        }, rest[key]), _resolver);
      } else if (process.env.NODE_ENV === 'development') {
        if (!['drag', 'pinch', 'scroll', 'wheel', 'move', 'hover'].includes(key)) {
          if (key === 'domTarget') {
            throw Error("[@use-gesture]: `domTarget` option has been renamed to `target`.");
          }

          console.warn("[@use-gesture]: Unknown config key `".concat(key, "` was used. Please read the documentation for further information."));
        }
      }
    }
  }

  return _config;
}

var EventStore = /*#__PURE__*/function () {
  function EventStore(ctrl, gestureKey) {
    _classCallCheck(this, EventStore);

    _defineProperty(this, "_listeners", new Set());

    this._ctrl = ctrl;
    this._gestureKey = gestureKey;
  }

  _createClass(EventStore, [{
    key: "add",
    value: function add(element, device, action, handler, options) {
      var listeners = this._listeners;
      var type = toDomEventType(device, action);

      var _options = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {};

      var eventOptions = _objectSpread2(_objectSpread2({}, _options), options);

      element.addEventListener(type, handler, eventOptions);

      var remove = function remove() {
        element.removeEventListener(type, handler, eventOptions);
        listeners.delete(remove);
      };

      listeners.add(remove);
      return remove;
    }
  }, {
    key: "clean",
    value: function clean() {
      this._listeners.forEach(function (remove) {
        return remove();
      });

      this._listeners.clear();
    }
  }]);

  return EventStore;
}();

var TimeoutStore = /*#__PURE__*/function () {
  function TimeoutStore() {
    _classCallCheck(this, TimeoutStore);

    _defineProperty(this, "_timeouts", new Map());
  }

  _createClass(TimeoutStore, [{
    key: "add",
    value: function add(key, callback) {
      var _window2;

      var ms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 140;
      this.remove(key);

      for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      this._timeouts.set(key, (_window2 = window).setTimeout.apply(_window2, [callback, ms].concat(args)));
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var timeout = this._timeouts.get(key);

      if (timeout) window.clearTimeout(timeout);
    }
  }, {
    key: "clean",
    value: function clean() {
      this._timeouts.forEach(function (timeout) {
        return void window.clearTimeout(timeout);
      });

      this._timeouts.clear();
    }
  }]);

  return TimeoutStore;
}();

var Controller = /*#__PURE__*/function () {
  function Controller(handlers) {
    _classCallCheck(this, Controller);

    _defineProperty(this, "gestures", new Set());

    _defineProperty(this, "_targetEventStore", new EventStore(this));

    _defineProperty(this, "gestureEventStores", {});

    _defineProperty(this, "gestureTimeoutStores", {});

    _defineProperty(this, "handlers", {});

    _defineProperty(this, "config", {});

    _defineProperty(this, "pointerIds", new Set());

    _defineProperty(this, "touchIds", new Set());

    _defineProperty(this, "state", {
      shared: {
        shiftKey: false,
        metaKey: false,
        ctrlKey: false,
        altKey: false
      }
    });

    resolveGestures(this, handlers);
  }

  _createClass(Controller, [{
    key: "setEventIds",
    value: function setEventIds(event) {
      if (isTouch(event)) {
        this.touchIds = new Set(touchIds(event));
        return this.touchIds;
      } else if ('pointerId' in event) {
        if (event.type === 'pointerup' || event.type === 'pointercancel') this.pointerIds.delete(event.pointerId);else if (event.type === 'pointerdown') this.pointerIds.add(event.pointerId);
        return this.pointerIds;
      }
    }
  }, {
    key: "applyHandlers",
    value: function applyHandlers(handlers, nativeHandlers) {
      this.handlers = handlers;
      this.nativeHandlers = nativeHandlers;
    }
  }, {
    key: "applyConfig",
    value: function applyConfig(config, gestureKey) {
      this.config = parse(config, gestureKey);
    }
  }, {
    key: "clean",
    value: function clean() {
      this._targetEventStore.clean();

      var _iterator = _createForOfIteratorHelper(this.gestures),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          this.gestureEventStores[key].clean();
          this.gestureTimeoutStores[key].clean();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "effect",
    value: function effect() {
      var _this = this;

      if (this.config.shared.target) this.bind();
      return function () {
        return _this._targetEventStore.clean();
      };
    }
  }, {
    key: "bind",
    value: function bind() {
      var _this2 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var sharedConfig = this.config.shared;
      var props = {};
      var target;

      if (sharedConfig.target) {
        target = sharedConfig.target();
        if (!target) return;
      }

      if (sharedConfig.enabled) {
        var _iterator2 = _createForOfIteratorHelper(this.gestures),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var gestureKey = _step2.value;
            var gestureConfig = this.config[gestureKey];
            var bindFunction = bindToProps(props, gestureConfig.eventOptions, !!target);

            if (gestureConfig.enabled) {
              var Engine = EngineMap.get(gestureKey);
              new Engine(this, args, gestureKey).bind(bindFunction);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        var nativeBindFunction = bindToProps(props, sharedConfig.eventOptions, !!target);

        var _loop = function _loop(eventKey) {
          nativeBindFunction(eventKey, '', function (event) {
            return _this2.nativeHandlers[eventKey](_objectSpread2(_objectSpread2({}, _this2.state.shared), {}, {
              event: event,
              args: args
            }));
          }, undefined, true);
        };

        for (var eventKey in this.nativeHandlers) {
          _loop(eventKey);
        }
      }

      for (var handlerProp in props) {
        props[handlerProp] = chain.apply(void 0, _toConsumableArray(props[handlerProp]));
      }

      if (!target) return props;

      for (var _handlerProp in props) {
        var _parseProp = parseProp(_handlerProp),
            device = _parseProp.device,
            capture = _parseProp.capture,
            passive = _parseProp.passive;

        this._targetEventStore.add(target, device, '', props[_handlerProp], {
          capture: capture,
          passive: passive
        });
      }
    }
  }]);

  return Controller;
}();

function setupGesture(ctrl, gestureKey) {
  ctrl.gestures.add(gestureKey);
  ctrl.gestureEventStores[gestureKey] = new EventStore(ctrl, gestureKey);
  ctrl.gestureTimeoutStores[gestureKey] = new TimeoutStore();
}

function resolveGestures(ctrl, internalHandlers) {
  if (internalHandlers.drag) setupGesture(ctrl, 'drag');
  if (internalHandlers.wheel) setupGesture(ctrl, 'wheel');
  if (internalHandlers.scroll) setupGesture(ctrl, 'scroll');
  if (internalHandlers.move) setupGesture(ctrl, 'move');
  if (internalHandlers.pinch) setupGesture(ctrl, 'pinch');
  if (internalHandlers.hover) setupGesture(ctrl, 'hover');
}

var bindToProps = function bindToProps(props, eventOptions, withPassiveOption) {
  return function (device, action, handler) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var isNative = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    var _options$capture, _options$passive;

    var capture = (_options$capture = options.capture) !== null && _options$capture !== void 0 ? _options$capture : eventOptions.capture;
    var passive = (_options$passive = options.passive) !== null && _options$passive !== void 0 ? _options$passive : eventOptions.passive;
    var handlerProp = isNative ? device : toHandlerProp(device, action, capture);
    if (withPassiveOption && passive) handlerProp += 'Passive';
    props[handlerProp] = props[handlerProp] || [];
    props[handlerProp].push(handler);
  };
};

var RE_NOT_NATIVE = /^on(Drag|Wheel|Scroll|Move|Pinch|Hover)/;

function sortHandlers(_handlers) {
  var native = {};
  var handlers = {};
  var actions = new Set();

  for (var key in _handlers) {
    if (RE_NOT_NATIVE.test(key)) {
      actions.add(RegExp.lastMatch);
      handlers[key] = _handlers[key];
    } else {
      native[key] = _handlers[key];
    }
  }

  return [handlers, native, actions];
}

function registerGesture(actions, handlers, handlerKey, key, internalHandlers, config) {
  if (!actions.has(handlerKey)) return;

  if (!EngineMap.has(key)) {
    if (process.env.NODE_ENV === 'development') {
      console.warn("[@use-gesture]: You've created a custom handler that that uses the `".concat(key, "` gesture but isn't properly configured.\n\nPlease add `").concat(key, "Action` when creating your handler."));
    }

    return;
  }

  var startKey = handlerKey + 'Start';
  var endKey = handlerKey + 'End';

  var fn = function fn(state) {
    var memo = undefined;
    if (state.first && startKey in handlers) handlers[startKey](state);
    if (handlerKey in handlers) memo = handlers[handlerKey](state);
    if (state.last && endKey in handlers) handlers[endKey](state);
    return memo;
  };

  internalHandlers[key] = fn;
  config[key] = config[key] || {};
}

function parseMergedHandlers(mergedHandlers, mergedConfig) {
  var _sortHandlers = sortHandlers(mergedHandlers),
      _sortHandlers2 = _slicedToArray(_sortHandlers, 3),
      handlers = _sortHandlers2[0],
      nativeHandlers = _sortHandlers2[1],
      actions = _sortHandlers2[2];

  var internalHandlers = {};
  registerGesture(actions, handlers, 'onDrag', 'drag', internalHandlers, mergedConfig);
  registerGesture(actions, handlers, 'onWheel', 'wheel', internalHandlers, mergedConfig);
  registerGesture(actions, handlers, 'onScroll', 'scroll', internalHandlers, mergedConfig);
  registerGesture(actions, handlers, 'onPinch', 'pinch', internalHandlers, mergedConfig);
  registerGesture(actions, handlers, 'onMove', 'move', internalHandlers, mergedConfig);
  registerGesture(actions, handlers, 'onHover', 'hover', internalHandlers, mergedConfig);
  return {
    handlers: internalHandlers,
    config: mergedConfig,
    nativeHandlers: nativeHandlers
  };
}

export { Controller, parseMergedHandlers };